import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { TitleVerdict } from '@/modules/jobs/signal/types';
import { toTitleVerdict } from '@/modules/jobs/signal/verdict';

/**
 * Lints a job title via `/ai/title-lint` (a billable LLM call — call it on title-commit, not per keystroke). The
 * wire `verdict` (a bare `string`) is narrowed to the local union here; `suggestion` is ignored — the screen renders
 * a static nudge, not a backend-proposed rewrite.
 */
export const useTitleLintMutation = () =>
  useMutation({
    mutationFn: async (title: string): Promise<TitleVerdict> => {
      const { data } = await fetchClient.POST('/ai/title-lint', {
        body: { title },
      });
      return toTitleVerdict(data?.verdict ?? 'specific');
    },
  });
